<template lang="html">
    <article class="xmessage">
      <div class="xmessage-body">
        <div class="content">
          <!-- <span v-for="riga in this.config.help" v-html="riga"></span> -->
          <span v-for="(riga, index) in parsedHelp" :key="index" v-html="riga"></span>
        </div>
    </div>
    </article>
</template>

<script>

export default {
  name: 'bulmaHelp',
  components: {
  },
  computed: {
    config: function() {
      //return this.$store.getters.getObject(this.id).data;
      const obj = this.$store.getters.getObject(this.id);
      return obj ? obj.data : {};
    },
    parsedHelp() {
      if (!this.config || !this.config.help) return [];

      const name = this.$store.state.myprofile.username || 'Utente';
      const email = this.$store.state.userid || '';

      return this.config.help.map(riga => {
        return riga
          .replace(/\{\s*user\.name\s*\}/g, name)
          .replace(/\{\s*user\.email\s*\}/g, email);
      });
    }
  },
  props: {
    id: String,
  },
  data() {
    return {
    }
  },
  mounted: function() {},
  async created() {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
